module.exports = __webpack_public_path__ + "img/lk-double-up.1569c621.svg";